import { ChevronUpIcon } from "@radix-ui/react-icons";
import { useEffect, useState } from "react";

export function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when scrolled down 300px
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }

      // Check if at bottom of page (within 100px)
      const scrollHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset;
      const clientHeight = document.documentElement.clientHeight;

      if (scrollHeight - scrollTop - clientHeight < 100) {
        setIsAtBottom(true);
      } else {
        setIsAtBottom(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    toggleVisibility(); // Check initial state

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });
  };

  // Animate via `transform: translate-y` and `opacity` only so the motion
  // runs on the compositor. Previously this toggled `bottom-8` ↔ `bottom-24`,
  // which Lighthouse flagged as a non-composited animation (the `bottom`
  // property is layout-driving, not compositor-driving).
  const restingY = isAtBottom ? "-translate-y-16" : "translate-y-0";
  const visibleY = isVisible ? restingY : "translate-y-4";
  const visibleOpacity = isVisible
    ? "opacity-100"
    : "opacity-0 pointer-events-none";

  return (
    <button
      aria-label="Back to top"
      className={`
        fixed bottom-8 right-8 z-50 p-3 rounded-full
        bg-white dark:bg-slate-800
        text-slate-600 dark:text-slate-300
        shadow-lg dark:shadow-slate-900/50
        hover:bg-slate-50 dark:hover:bg-slate-700
        hover:text-slate-900 dark:hover:text-white
        transition-[transform,opacity] duration-300 ease-in-out
        cursor-pointer
        ${visibleOpacity}
        ${visibleY}
      `}
      onClick={scrollToTop}
      type="button"
    >
      <ChevronUpIcon className="h-5 w-5" />
    </button>
  );
}
